module.exports = __webpack_public_path__ + "static/media/coffee-4.1aa8db7e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/sponsorships/slider/coffee-4.jpg
// module id = 591
// module chunks = 6